let env;
let mock;

if (typeof location !== 'undefined') {
  env = location.host.split('.')[0].match(/(qc|box)\d?/g);
  mock = location.href.match(/[&?]mock=([^&]*)/);

  env = !!env ? (env.length > 0 ? `-${env[0]}` : '') : '';

  // localhost环境下可以通过mock参数设置接口环境
  // http://localhost:8080/?mock=box3
  if (location.host.indexOf('localhost') !== -1 && mock) {
    env = '-' + mock[1];
  }
} else {
  env = process.env.NODE_ENV !== 'production' ? '-box3' : '';
}

const cpapiHost = `//m-cpapi${env}.xinli001.com/cp/mservice/`;
const quHost = `//qu${env}.xinli001.com/lingxi/`;
const lingxiHost = `//m-lingxi${env}.xinli001.com/lingxi/service/`;
const LXKC = `//kc${env}.xinli001.com/lingxikc/`

// const cpapiHost = `//cpapi-box3.xinli001.com/cp/mservice/`;
// const quHost = `//qu-box3.xinli001.com/lingxi/`;
// const lingxiHost = `//lingxi-box3.xinli001.com/lingxi/service/`;

export default {
  env,
  cpapiHost,
  quHost,
  lingxiHost,
  LXKC,
  wxConfig: `/lx/wx/jsConfig`, //  微信初始化信息

  // 生产环境在axios拦截器修正地址，开发模式用http-proxy-middleware
  getHandpickScales: '/api/index/getHandpickScales',
  getCategorysAndHotScales: '/api/index/getCategorysAndHotScales',

  recommendsSearch: '/qu/fun/platform/recommendsSearch',
  getFunRecommends: '/qu/fun/getFunRecommends',
  search: '/qu/fun/platform/search',

  getSort: '/api/category/getCategoryScales',
  getCoupon: `${lingxiHost}coupon/receiveCoupon`,
  // buyCpVip: `${LXKC}api/buyCpVip`, // 购买测评会员

  getConfigureByCode: `https://yiapp${env}.xinli001.com/commonConfigure/getConfigureByCode`,  // 后台配置
  getScaleDetailIntro: `${cpapiHost}getScaleDetailIntro`,  // 详情页数据
}



// WEBPACK FOOTER //
// ./src/util/apis.js